import { render, staticRenderFns } from "./DecisionDocument.vue?vue&type=template&id=e19d9002"
import script from "./DecisionDocument.vue?vue&type=script&lang=js"
export * from "./DecisionDocument.vue?vue&type=script&lang=js"
import style0 from "./DecisionDocument.vue?vue&type=style&index=0&id=e19d9002&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports